import React, { Component } from "react";
import "./RadioIcon.css";
import "../Styles/SvgCommand.css";

const AttachmentIcon = (props) => {
  return (
    <svg
      height="15px"
      viewBox="0 0 20 20"
      width="15px"
      className="radioChecked"
      onClick={props.click}
    >
      <g
        fill="none"
        fillRule="evenodd"
        id="Page-1"
        stroke="none"
        strokeWidth="1"
      >
        {props.checked ? (
          <g
            fill="#008dff"
            id="Core"
            transform="translate(-338.000000, -338.000000)"
          >
            <g
              id="radio-button-on"
              transform="translate(338.000000, 338.000000)"
            >
              <path
                d="M10,5 C7.2,5 5,7.2 5,10 C5,12.8 7.2,15 10,15 C12.8,15 15,12.8 15,10 C15,7.2 12.8,5 10,5 L10,5 Z M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 L10,0 Z M10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 C14.4,2 18,5.6 18,10 C18,14.4 14.4,18 10,18 L10,18 Z"
                id="Shape"
              />
            </g>
          </g>
        ) : (
          <g
            fill="#008dff"
            id="Core"
            transform="translate(-296.000000, -338.000000)"
          >
            <g
              id="radio-button-off"
              transform="translate(296.000000, 338.000000)"
            >
              <path
                d="M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 L10,0 Z M10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 C14.4,2 18,5.6 18,10 C18,14.4 14.4,18 10,18 L10,18 Z"
                id="Shape"
              />
            </g>
          </g>
        )}
      </g>
    </svg>
  );
};

export default AttachmentIcon;
